<template>
    <div class="echars">
      <div id="echarth-gangwei"></div>
    </div>
</template>

<script>
export default {
  name: "echarth-gangwei",
  props:["title"],
  data() {
    return {
      data: [],
    }
  },
  watch: {
        title: function (newData) {
           let value1 = newData[0]
            // this.value1.forEach((item,index)=>{
            //     this.data.forEach((item1,index1)=>{
            //         if(item1.name===item.sf){
            //             this.data[index1] = {name:`${item.sf}`,value:item.count}
            //         }
                    
            //     })
            // })
            this.mapFn(value1)
        }
    },
  methods: {
    mapFn(value1) {
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      var mapChart = this.$echarts.init(document.getElementById("echarth-gangwei"));
      document.getElementById("echarth-gangwei").removeAttribute('_echarts_instance_')
      mapChart.setOption({
        tooltip: {
            trigger: 'item',
            
        },
         grid : {
        top : 30,
        left: 90
        
    },
        xAxis: {
          boundaryGap: false,
          type: "category",
          data: [
            "管理人员",
            "工人",
            "特种",
          ],
          axisLabel: {
            interval: 0  //设置间隔为0
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cccccc",
            },
          },
        },
        yAxis: {
          min: 0, // 刻度最小值
          // max: 200, // 刻度最大值（需要动态获取最大值,并且能被3整除（向下取整再乘回来））
          splitNumber: 4, // 横线数
          interval: 25, // 刻度间隔
          // data: [0, 60, 100, 160, 200],
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cccccc",
            },
          },
        },
        series: [
          {
            type: "line",
            smooth: true,
            // symbol: 'circle', // 拐点类型
            symbolSize: 12, // 拐点圆的大小
            itemStyle: {
              normal: {
                color: "#34a1f7", // 折线条的颜色
                areaStyle: {
                  type: "default",
                  opacity: 0.3,
                },
              },
            },
            data: [value1.managerCount, value1.workCount, value1.otherCount],
          },
        ],
      }),
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          mapChart.resize();
        });
    },
  },
};
</script>
<style scoped>
.echars{
  width: 20vw;
  height: 38vh;
}
#echarth-gangwei{
  width: 20vw;
  height: 38vh;
}
</style>
